import React from 'react'
import styled from 'styled-components'

import { SortIcon } from './SortIcon'

export type SortingDirection = 'ASC' | 'DESC'

interface Props {
  headings: {
    key: string
    label: string
    sortable?: boolean
  }[]
  onSorting?: (key: string, direction: SortingDirection) => void
  sortDirection?: SortingDirection
  sortKey?: string
  className?: string
  clickableRows?: boolean
  hover?: boolean
}

export const Table: React.FC<Props> = ({
  headings,
  onSorting,
  sortDirection,
  hover,
  clickableRows,
  children,
  sortKey,
  className,
}) => {
  return (
    <Wrapper>
      <TableWrapper
        cellPadding={0}
        cellSpacing={0}
        className={className}
        clickableRows={clickableRows}
        hover={hover}
      >
        <thead>
          <tr>
            {headings.map(item => (
              <th key={item.key}>
                {item.sortable && sortDirection ? (
                  <SortableHead
                    onClick={() => {
                      const isActiveAlready = item.key === sortKey
                      const newDirection =
                        sortDirection === 'DESC' && isActiveAlready
                          ? 'ASC'
                          : 'DESC'
                      if (onSorting) {
                        onSorting(item.key, newDirection)
                      }
                    }}
                  >
                    <span>{item.label}</span>
                    <SortIcon
                      activeDirection={
                        (item.key === sortKey && sortDirection) || undefined
                      }
                    />
                  </SortableHead>
                ) : (
                  <span>{item.label}</span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        {children}
      </TableWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  overflow-x: auto;
`

interface TableWrapperProps {
  clickableRows?: boolean
  hover?: boolean
}

const TableWrapper = styled.table<TableWrapperProps>`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.color.neutri.grigioMedio};
  border-radius: 20px;
  overflow: hidden;
  background-image: linear-gradient(
    88.21deg,
    #ce2bf7 -3.22%,
    #597eff 41.78%,
    #01579b 88.69%
  );

  thead {
    tr {
      color: #fff;
    }

    th {
      text-align: left;
      font-weight: 700;
      padding: 1.5rem 1rem;
      line-height: 1.3;
    }
  }

  tbody {
    background: #fff;
    td {
      font-size: 0.875rem;
      padding: 1rem;
    }

    tr {
      cursor: ${({ clickableRows }) => (clickableRows ? 'pointer' : null)};
    }

    tr:nth-of-type(even) {
      background-color: ${({ theme }) => theme.color.neutri.grigioBg};
    }

    tr:hover {
      background-color: ${({ hover, theme }) =>
        hover ? theme.color.neutri.grigioChiaro : null};
    }
  }
`

const SortableHead = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    margin-left: 1rem;
  }
`
